export enum AddressInvoiceType {
    Company = 'company',
    Individual = 'individual'
}

export interface Address {
    firstName: string;
    lastName: string;
    gender: number | null;
    city: string;
    postCode: string;
    street: string;
    phone: string;
    country: string;
    customerNotes: string | null;
    invoiceNote?: string | null;

    /** Selected InPost machine box */
    inpostPoint: string | null;

    /** Selected DHL pick up point */
    dhlPoint: string | null;

    /** Selected DDP pick up point */
    dpdPoint: string | null;

    /**
     * Is invoice requested.
     * Makes sense only for billing address,
     * but for the sake of consistency it's everywhere.
     */
    invoice: boolean;
    invoiceType?: AddressInvoiceType | undefined;

    /**
     * Company name.
     * Makes sense only if invoice is requested.
     */
    companyName: string | null;

    /**
     * Company tax Id (NIP in PL).
     * Makes sense only if invoice is requested.
     */
    companyTaxId: string | null;

    defaultBilling?: boolean | null;
    defaultShipping?: boolean | null;
}
